import api from './client';
import type { AxiosResponse } from 'axios';

interface RestaurantSearchParams {
  budget?: string;
  cuisine?: string;
  query?: string;
  location?: string;
}

interface ReservationData {
  restaurant_id: string;
  date: string;
  time: string;
  party_size?: number;
  match_id?: string;
}

interface ExperienceSearchParams {
  budget?: string;
  category?: string;
  query?: string;
  location?: string;
}

interface ExperienceBookingData {
  experience_id: string;
  date: string;
  participants?: number;
  match_id?: string;
}

interface FlowerSendData {
  flower_id: string;
  match_id?: string;
  message?: string;
}

// Google Places (Restaurants)
export const searchRestaurants = (params: RestaurantSearchParams = {}): Promise<AxiosResponse> => {
  const q = new URLSearchParams();
  if (params.budget) q.append('budget', params.budget);
  if (params.cuisine) q.append('cuisine', params.cuisine);
  if (params.query) q.append('query', params.query);
  if (params.location) q.append('location', params.location);
  return api.get(`/affiliates/restaurants/search?${q.toString()}`);
};
export const makeReservation = (data: ReservationData): Promise<AxiosResponse> => {
  const q = new URLSearchParams({ restaurant_id: data.restaurant_id, date: data.date, time: data.time, party_size: String(data.party_size || 2) });
  if (data.match_id) q.append('match_id', data.match_id);
  return api.post(`/affiliates/restaurants/reserve?${q.toString()}`);
};
export const getReservations = (): Promise<AxiosResponse> => api.get('/affiliates/restaurants/reservations');

// Viator
export const searchExperiences = (params: ExperienceSearchParams = {}): Promise<AxiosResponse> => {
  const q = new URLSearchParams();
  if (params.budget) q.append('budget', params.budget);
  if (params.category) q.append('category', params.category);
  if (params.query) q.append('query', params.query);
  if (params.location) q.append('location', params.location);
  return api.get(`/affiliates/viator/experiences?${q.toString()}`);
};
export const bookExperience = (data: ExperienceBookingData): Promise<AxiosResponse> => {
  const q = new URLSearchParams({ experience_id: data.experience_id, date: data.date, participants: String(data.participants || 2) });
  if (data.match_id) q.append('match_id', data.match_id);
  return api.post(`/affiliates/viator/book?${q.toString()}`);
};
export const getExperienceBookings = (): Promise<AxiosResponse> => api.get('/affiliates/viator/bookings');

// 1-800-Flowers
export const getFlowerCatalog = (category?: string): Promise<AxiosResponse> => api.get(`/affiliates/flowers/catalog${category ? `?category=${category}` : ''}`);
export const sendFlowers = (data: FlowerSendData): Promise<AxiosResponse> => {
  const q = new URLSearchParams({ flower_id: data.flower_id });
  if (data.match_id) q.append('match_id', data.match_id);
  if (data.message) q.append('message', data.message);
  return api.post(`/affiliates/flowers/send?${q.toString()}`);
};
export const getFlowerOrders = (): Promise<AxiosResponse> => api.get('/affiliates/flowers/orders');
export const getAllBookings = (): Promise<AxiosResponse> => api.get('/affiliates/bookings');

// Misc affiliates
export const getAffiliateVenues = (budget: string, location: string): Promise<AxiosResponse> => api.post('/affiliates/venues', { budget, location });
export const getFlowerSuggestions = (): Promise<AxiosResponse> => api.get('/affiliates/flowers');
export const getNeutralSpots = (location?: string, budget?: string): Promise<AxiosResponse> => api.post(`/venues/neutral-spots?location=${encodeURIComponent(location || 'New York')}&budget=${budget || '$$'}`);
